import { Unary } from '@vaaas/fpts/data';
import { Result } from '@vaaas/fpts/result';

export type Defined<X> = Exclude<X, undefined>;

export const as = <T>(x: any) => x as T;

export type Parser<T> = Unary<unknown, Result<T>>;
